

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { BocciaturaConsegnaFase1 } from "src/app/models/dto/bocciaturaFase1.model";
import { BocciaturaConsegnaFase2 } from "src/app/models/dto/bocciaturaFase2.model";
import { BocciaturaConsegnaFase3 } from "src/app/models/dto/bocciaturaFase3.model";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";

  

@Component({
    selector: "app-verifica-consegna-fase3",
    templateUrl: "./dialog-verifica_consegna_fase3.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogVerificaConsegnaFase3 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;

    protected verificaRETForm: FormGroup;
    protected verificaPSIForm: FormGroup;
    protected verificaSUBIRUForm: FormGroup;
    protected verificaNT9Form: FormGroup;

    protected isVerificandoConsegna:boolean = false;
    
    protected pagineValidaConsegna: MenuItem[];
    protected activeIndex: number = 0;
    selectAll: boolean = false; 

    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
    ) {
      this.pratica          = this.config.data.pratica;
     
      this.verificaRETForm = this.formBuilder.group({
        firma                             : [false],
        sedi                              : [false],
        premessa                          : [false],
        quesito169                        : [false],
        dettagliFisici                    : [false],
        dettagliLogici                    : [false],
        dettagliParametriOfferta          : [false],
        dettaglioCollegamentoReteAccesso  : [false],
        noteRET  : [null],
        selectAll                         : [ false]  
      });
    
      this.verificaPSIForm = this.formBuilder.group({
        planimetria           : [ false],
        notePSI               : [ null],
        selectAll             : [ false]  
       });
      
      this.verificaSUBIRUForm = this.formBuilder.group({
        annoCessione              : [ false],
        attestazioneA             : [ false],
        attestazioneZ             : [ false],
        centrale                  : [ false],
        noteSUBIRU                 : [ null],
        selectAll                 : [ false]  
       });

      this.verificaNT9Form = this.formBuilder.group({
        shp                     : [ false],
        csv                     : [ false],
        coerenzaConPacchetto   : [ false],
        noteNT9   : [ null],
        selectAll               : [ false]  
       });
       
    }

   
    toggleAllFieldsFormRET(): void {
      this.logger.info("** toggleAllFieldsFormVerbale **");
      this.verificaRETForm.setValue({
        firma:                              this.verificaRETForm.get('selectAll').value,
        sedi:                               this.verificaRETForm.get('selectAll').value,
        premessa:                           this.verificaRETForm.get('selectAll').value,
        quesito169:                         this.verificaRETForm.get('selectAll').value,
        dettagliFisici:                     this.verificaRETForm.get('selectAll').value,
        dettagliLogici:                     this.verificaRETForm.get('selectAll').value,
        dettagliParametriOfferta:           this.verificaRETForm.get('selectAll').value,
        dettaglioCollegamentoReteAccesso:   this.verificaRETForm.get('selectAll').value,
        noteRET:                            this.verificaRETForm.get('noteRET').value,
        selectAll :                         this.verificaRETForm.get('selectAll').value
      });
     
    }
    toggleAllFieldsFormPSI(): void {
      this.logger.info("** toggleAllFieldsFormRET **");
      this.verificaPSIForm.setValue({
        planimetria:      this.verificaPSIForm.get('selectAll').value,
        notePSI:          this.verificaPSIForm.get('notePSI').value,
        selectAll :       this.verificaPSIForm.get('selectAll').value
      });
    }

    toggleAllFieldsFormSUBIRU(): void {
      this.logger.info("** toggleAllFieldsverificaSUBIRUForm **");
      this.verificaSUBIRUForm.setValue({
        annoCessione:     this.verificaSUBIRUForm.get('selectAll').value,
        attestazioneA:    this.verificaSUBIRUForm.get('selectAll').value,
        attestazioneZ:    this.verificaSUBIRUForm.get('selectAll').value,
        centrale:         this.verificaSUBIRUForm.get('selectAll').value,
        noteSUBIRU:       this.verificaSUBIRUForm.get('noteSUBIRU').value,
        selectAll :       this.verificaSUBIRUForm.get('selectAll').value
      });
    }

    toggleAllFieldsFormNT9(): void {
      this.logger.info("** toggleAllFieldsverificaNT9Form **");
      this.verificaNT9Form.setValue({
        shp:                      this.verificaNT9Form.get('selectAll').value,
        csv:                      this.verificaNT9Form.get('selectAll').value,
        coerenzaConPacchetto:     this.verificaNT9Form.get('selectAll').value,
        noteNT9:                  this.verificaNT9Form.get('noteNT9').value,
        selectAll :               this.verificaNT9Form.get('selectAll').value
      });
    }

    ngOnInit(): void {
      this.inizializzaSteps();
    }

    inizializzaSteps() {
      this.pagineValidaConsegna = [
        {
          label: "RET",
        },
        {
          label: "PSI",
        },
        {
          label: "SUB-IRU",
        },
        {
          label: "PACCHETTO NT9",
        }
       ];
      this.activeIndex = 0;
    }

    checkNextStep(): boolean {
      let disableNextStepButton = false;
      if (this.activeIndex === this.pagineValidaConsegna.length - 1) {
        disableNextStepButton = true;
      }else if (this.activeIndex === 0 && !this.verificaRETForm.valid) {
        disableNextStepButton = true;
      }else if (this.activeIndex === 1 && !this.verificaPSIForm.valid) {
        disableNextStepButton = true;
      }else if (this.activeIndex === 2 && !this.verificaSUBIRUForm.valid) {
        disableNextStepButton = true;
      }else if (this.activeIndex === 3 && !this.verificaNT9Form.valid) {
        disableNextStepButton = true;
      }
      return disableNextStepButton;
    }

    changePage() {
      this.activeIndex = this.activeIndex + 1;
    
    }

   
    
    isRETOK(): boolean {
      const formValues = this.verificaRETForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') // Considera solo i booleani
        .every((key) => formValues[key] === true); // Verifica che siano true
    }
    getRETKOFields(): string[] {
      const formValues = this.verificaRETForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') 
        .filter((key) => formValues[key] === false); 
    }
    isPSIOK(): boolean {
      const formValues = this.verificaPSIForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') // Considera solo i booleani
        .every((key) => formValues[key] === true); // Verifica che siano true
    }
    getPSIKOFields(): string[] {
      const formValues = this.verificaPSIForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') 
        .filter((key) => formValues[key] === false); 
    }
    isNT9OK(): boolean {
      const formValues = this.verificaNT9Form.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') // Considera solo i booleani
        .every((key) => formValues[key] === true); // Verifica che siano true
    }
    getNT9KOFields(): string[] {
      const formValues = this.verificaNT9Form.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') 
        .filter((key) => formValues[key] === false); 
    }
    isSUBIRUOK(): boolean {
      const formValues = this.verificaSUBIRUForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') // Considera solo i booleani
        .every((key) => formValues[key] === true); // Verifica che siano true
    }
    getSUBIRUKOFields(): string[] {
      const formValues = this.verificaSUBIRUForm.getRawValue();
      return Object.keys(formValues)
        .filter((key) => typeof formValues[key] === 'boolean') 
        .filter((key) => formValues[key] === false); 
    }



    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isVerificandoConsegna = true;
        if( this.isRETOK() && this.isPSIOK() && this.isSUBIRUOK() && this.isNT9OK()){
          //TUTTO OK VALIDO
           this.praticheService.presidioValidaConsegnaFase3(this.pratica.id).subscribe( {
            next: (v) => {
              this.isVerificandoConsegna = false;
              this.dialogRef.close({ success: true});
            },
            error: (e) => {
                this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di validazione della consegna della FASE 3 della pratica'});
                this.dialogRef.close({ success: false });
            },complete: () => {

            }
          }); 
        }else{
          let reportBocciaturaFase3:BocciaturaConsegnaFase3 = new BocciaturaConsegnaFase3();
          if(this.isRETOK()){
            reportBocciaturaFase3.retOK = true;
            
          }else{
            reportBocciaturaFase3.retOK = false;
            reportBocciaturaFase3.noteRET = this.verificaRETForm.value.noteRET;
            reportBocciaturaFase3.problemiRET = this.getRETKOFields();
          }
          if(this.isPSIOK()){
            reportBocciaturaFase3.psiOK = true;
          }else{
            reportBocciaturaFase3.psiOK        = false;
            reportBocciaturaFase3.notePSI      = this.verificaPSIForm.value.notePSI;
            reportBocciaturaFase3.problemiPSI  = this.getPSIKOFields();
          }
          if(this.isNT9OK()){
            reportBocciaturaFase3.nt9OK = true;
          }else{
            reportBocciaturaFase3.nt9OK        = false;
            reportBocciaturaFase3.noteNT9      = this.verificaNT9Form.value.noteNT9;
            reportBocciaturaFase3.problemiNT9  = this.getNT9KOFields();
          }
          if(this.isSUBIRUOK()){
            reportBocciaturaFase3.subiruOK = true;
          }else{
            reportBocciaturaFase3.subiruOK        = false;
            reportBocciaturaFase3.noteSUBIRU      = this.verificaSUBIRUForm.value.noteSUBIRU;
            reportBocciaturaFase3.problemiSUBIRU  = this.getSUBIRUKOFields();
          }
         
          this.logger.info(reportBocciaturaFase3);
           this.praticheService.presidioBocciaConsegnaFase3(this.pratica.id, reportBocciaturaFase3).subscribe( {
            next: (res) => {
              this.isVerificandoConsegna = false;
              this.dialogRef.close({ success: true});
            },  error: (e) => {
              this.isVerificandoConsegna = false;
              this.messageService.add({
                severity: "info",
                summary: "Errore" , life:10000,
                  detail: "Errore in fase di validazione della consegna di FASE 2!",
                });
              this.dialogRef.close({ success: false });
            },
            complete: () => {

            }
          } 
        );
        
        }
        
      } 
    }
  
  }